import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private httpHeader = new HttpHeaders();

  constructor(
    private http: HttpClient,
    private _global: Globals,
    private configService: ConfigurationsService
  ) {
    this.httpHeader.append('Access-Control-Allow-Origin', '*');
  }

  DeleteUserbyUserId(UserId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'UserManagement' +
      '/DeleteUserbyUserId?UserId=' +
      UserId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get User List
  GetUserList(CompanyId: any, LoginId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'UserManagement' +
      '/GetUserIdBasedonCompanyLoginId?CompanyId=' +
      CompanyId +
      '&LoginId=' +
      LoginId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get User List
  GetRoleList() {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Common' +
      '/GetRoleListDropdown';
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get Site Energy Meter List
  GetSiteEnergyMeterList(CompanyId: any, UserId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'AssignEnergymeter' +
      '/GetCompanyWiseSiteEnergymeterList?companyId=' +
      CompanyId +
      '&userId=' +
      UserId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }
  GetProcessWiseSiteEnergymeterList(CompanyId: any, UserId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'AssignEnergymeter' +
      '/GetProcessWiseSiteEnergymeterList?companyId=' +
      CompanyId +
      '&processId=' +
      UserId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  // Method is used for Add Company
  AddCompany(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Company' +
      '/InsertUpdateCompany';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Assign Energy Meter
  AssignEnergymeter(CompanyId: any, UserId: any, EnergyMasterIds: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'AssignEnergymeter' +
      '/AssignEnergymeter?UserId=' +
      UserId +
      '&companyId=' +
      CompanyId +
      '&energymeterId=' +
      EnergyMasterIds;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get Company Details
  GetCompanyDetails(CompanyId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Company' +
      '/GetCompanyDetails?CompanyId=' +
      CompanyId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Delete Company by Id
  DeleteCompanybyCompanyId(CompanyId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Company' +
      '/DeleteCompanybyCompanyId?CompanyId=' +
      CompanyId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method to check Energy Meter Exist
  CheckEnergyMeterExist(EnergyMeterId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'AssignEnergyMeter' +
      '/CheckEnergyMeterExist?EnergyMeterId=' +
      EnergyMeterId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  GetEnergyMeterIdList(SiteId: any, PanelId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Common' +
      '/GetEnergyMeterIdList?SiteId=' +
      SiteId +
      '&PanelId=' +
      PanelId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  GetReportData(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetReportData';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  ExportReportinPDF(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Report' +
      '/ExportReportinPDF';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  SendReportPDFbyEmail(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Report' +
      '/SendReportPDFbyEmail';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Add Company
  GetGraphDetails(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard' +
      '/GetEnergymeterDetailsByRange';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  GetGraphConfigurationList(CompanyId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard' +
      '/GetGraphConfigurationList?CompanyId=' +
      CompanyId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  GetGraphConfigDetailsbyId(GraphConfigId: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard' +
      '/GetGraphConfigDetailsbyId?GraphConfigId=' +
      GraphConfigId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  TransGraphConfigDetails(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard' +
      '/TransGraphConfigDetails';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  ReportConfigTimingDetails(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard' +
      '/ReportConfigTimingDetails';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }
  CustomEmailConfigTimingDetails(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard' +
      '/CustomEmailConfigTimingDetails';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }
  ReportDatabyGraphConfigId(
    GraphConfigId: any,
    companyId: any
  ): Observable<any> {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard/ReportDatabyGraphConfigId?GraphConfigId=' +
      GraphConfigId +
      '&CompanyId=' +
      companyId;
    return this.http
      .post(serviceCallURL, {
        GraphConfigId: GraphConfigId,
        companyId: companyId,
      })
      .pipe(
        map((resp: any) => resp),
        catchError(this._global.handleError)
      );
  }

  CustomEmailDatabyGraphConfigId(
    GraphConfigId: any,
    companyId: any
  ): Observable<any> {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Dashboard/CustomEmailDatabyGraphConfigId?GraphConfigId=' +
      GraphConfigId +
      '&CompanyId=' +
      companyId;
    return this.http
      .post(serviceCallURL, {
        GraphConfigId: GraphConfigId,
        companyId: companyId,
      })
      .pipe(
        map((resp: any) => resp),
        catchError(this._global.handleError)
      );
  }
  //Method os used for Update User Role
  UpdateUserRole(RoleId, UserId) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'UserManagement' +
      '/UpdateUserRole?UserId=' +
      UserId +
      '&RoleId=' +
      RoleId;
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  addItem(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      '/ServiceMaster/TransItemDetails';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get User List
  getItem() {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') + '/ServiceMaster/GeItemList';
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get User List
  getServiceMasterList() {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'ServiceMaster/GeServiceSpareDetailList';
    return this.http.get(serviceCallURL).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  addServiceMaster(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      '/ServiceMaster/TransServiceSpareDetails';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get User List
  getLoadChartList(req: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'FlowMeter/GetLoadReportData';
    return this.http.post(serviceCallURL, req).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }
  // Export Flow Report
  ExportLoadFlowReport(ReqObj: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') + 'Report/ExportFlowReport';
    return this.http.post(serviceCallURL, ReqObj).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }

  //Method is used for Get User List
  getServiceHistory(req: any) {
    let serviceCallURL: string =
      this.configService.serviceUrl('ServiceURL') +
      'Report/GetServiceDetailsReportData';
    return this.http.post(serviceCallURL, req).pipe(
      map((resp: any) => resp),
      catchError(this._global.handleError)
    );
  }
}
